@if (dossier) {
  <h4 mat-dialog-title>{{ dossier.numeroDossier }} - {{ candidat.nom | uppercase }}</h4>

  <mat-dialog-content>

    <div class="mb-1">
      <span>{{ 'front.modaleChangementCommission.commissionActuelle' | translate }} :</span>
      <br>
        {{ dossier.commissionTableau ? dossier.commissionTableau.label : "front.modaleChangementCommission.aucuneReunion" | translate }}
      </div>

      <div class="mb-1">

        <label>{{ 'front.modaleChangementCommission.selectNewReunion' | translate }} : *</label>
        <mat-select class="form-control" id="reunion" [(ngModel)]="commissionSeanceSelected"
          [compareWith]="compareByid"
          placeholder="{{'general.reunion' | translate}}" [disabled]="commissionDepasse">
          @for (commissionSeance of commissionSeances; track commissionSeance) {
            <mat-option [value]="commissionSeance">
              {{ commissionSeance.label }}
            </mat-option>
          }
        </mat-select>
      </div>

      @if (commissionDepasse) {
        <div role="alert">
          <div class="alert alert-danger" role="alert">
            {{ 'front.modaleChangementCommission.impossibleChangement' | translate }}
            "{{ dossier.commissionTableau.label }}
            " {{ 'front.modaleChangementCommission.carTermineLe' | translate }} {{ dossier.commissionTableau.datetimeDebut | date : dateShort }}
          </div>
          <br>
          </div>
        }

        <label>{{ 'general.justification' | translate }} : *</label>
        <br>
          <textarea name="justification" rows="5" class="form-control" [(ngModel)]="justification"
          id="justification" [disabled]="commissionDepasse"></textarea>


        </mat-dialog-content>

        <mat-dialog-actions>
          <button class="btn " [mat-dialog-close]="false"
            style="margin-right: 15px;">{{ 'general.annuler' | translate }}
          </button>
          <button mat-raised-button color="primary" type="submit" (click)="changerCommission()"
            [disabled]="commissionSeanceSelected===null || justification === null || justification.trim().length === 0">{{ 'general.changer' | translate }}
          </button>
        </mat-dialog-actions>

      }
